import { z } from 'zod';
import { c } from '../../contract';
import { DeepLinkData } from '../../types';

export const deepLinkingRouter = c.router(
  {
    data: c.router(
      {
        getBranchDeepLinkData: {
          summary: 'Gets data from a Branch deep link',
          method: 'GET',
          path: '/branch',
          query: z.object({
            link: z.string(),
          }),
          responses: {
            200: DeepLinkData,
          },
        },
      },
      { pathPrefix: '/data' },
    ),
  },
  {
    pathPrefix: '/deep-linking',
  },
);
